import { render, staticRenderFns } from "./ShirtStatus.vue?vue&type=template&id=4a8b53ad&scoped=true&"
import script from "./ShirtStatus.vue?vue&type=script&lang=js&"
export * from "./ShirtStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8b53ad",
  null
  
)

export default component.exports